import { render, staticRenderFns } from "./USFee.vue?vue&type=template&id=4ceae234&scoped=true&"
import script from "./USFee.vue?vue&type=script&lang=js&"
export * from "./USFee.vue?vue&type=script&lang=js&"
import style0 from "./USFee.vue?vue&type=style&index=0&id=4ceae234&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceae234",
  null
  
)

export default component.exports